import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
export default function Loader() {
    return (_jsx("div", { css: css `
        color: inherit !important;
        font-size: 0.85em !important;
        padding: 0.5em !important;
        text-align: center !important;
      `, children: "Loading..." }));
}
//# sourceMappingURL=Loader.js.map